/**
 * Placeholder illustration component for UUI demos.
 * The original @uui/shared-assets/illustrations module is not included in this vendor bundle.
 */
import type { ComponentProps } from "react"

type IllustrationType = "cloud" | "empty" | "error" | "search" | string
type IllustrationSize = "sm" | "md" | "lg" | "xl"
type IllustrationColor =
  | "gray"
  | "brand"
  | "error"
  | "warning"
  | "success"
  | string

export interface IllustrationProps extends ComponentProps<"div"> {
  name?: string
  type?: IllustrationType
  size?: IllustrationSize
  color?: IllustrationColor
  width?: number | string
  height?: number | string
}

const sizeMap: Record<IllustrationSize, { width: number; height: number }> = {
  sm: { width: 200, height: 150 },
  md: { width: 300, height: 225 },
  lg: { width: 400, height: 300 },
  xl: { width: 500, height: 375 },
}

export function Illustration({
  name,
  type = "cloud",
  size = "lg",
  color: _color = "gray",
  width,
  height,
  className,
  ...props
}: IllustrationProps) {
  const dimensions = sizeMap[size] || sizeMap.lg
  const finalWidth = width ?? dimensions.width
  const finalHeight = height ?? dimensions.height
  const displayName = name ?? type

  return (
    <div
      className={`bg-secondary border-secondary flex items-center justify-center rounded-lg border ${className ?? ""}`}
      style={{ width: finalWidth, height: finalHeight }}
      {...props}
    >
      <div className="text-tertiary text-center">
        <svg
          className="mx-auto mb-2 h-12 w-12 opacity-50"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <p className="text-sm">{displayName}</p>
      </div>
    </div>
  )
}
